import axiosClient from './axiosClient';

const quotesApi = {
  // Cotizador publico (sin autenticacion obligatoria)
  searchCatalogProducts: (search) => axiosClient.get('/catalog/products', { params: { search } }),

  // Listados curados del catalogo publico (home: en tendencia, mas vendido, ultimo en llegar)
  getCatalogProducts: (params) => axiosClient.get('/catalog/products', { params }),

  // Categorias del catalogo publico, para el filtro de "/catalogo" (sin autenticacion)
  getCatalogCategories: () => axiosClient.get('/catalog/categories'),

  // Ficha de detalle de un producto ("/productos/:id"), publica y sin autenticacion
  getCatalogProduct: (id) => axiosClient.get(`/catalog/products/${id}`),
  createQuote: (data) => axiosClient.post('/quotes', data),

  // Descarga del PDF de la cotizacion recien creada en "/cotizador", por UUID (sin autenticacion)
  downloadGuestQuotePdf: (uuid) => axiosClient.get(`/quotes/guest/${uuid}/pdf`, { responseType: 'blob' }),

  // Administracion de cotizaciones (administrador y tecnico)
  getQuotes: (params) => axiosClient.get('/quotes', { params }),
  // Cotizaciones del propio cliente autenticado (panel del cliente / "Mis cotizaciones").
  getMyQuotes: (params) => axiosClient.get('/quotes/mine', { params }),
  updateQuoteStatus: (id, status) => axiosClient.put(`/quotes/${id}`, { status }),
  deleteQuote: (id) => axiosClient.delete(`/quotes/${id}`),
  getQuoteStatuses: () => axiosClient.get('/quote-statuses'),
  // `paper`: 'a4' (default) o 'ticket' (80mm, para tiketera termica ej. Fukun FK-POS80-BF).
  downloadQuotePdf: (id, paper) => axiosClient.get(`/quotes/${id}/pdf`, { params: { paper }, responseType: 'blob' }),
  sendQuoteEmail: (id, email) => axiosClient.post(`/quotes/${id}/send-email`, email ? { email } : {}),
};

export default quotesApi;
